import { render, staticRenderFns } from "./UploadDetailsDrawer.vue?vue&type=template&id=cb02a4f2&scoped=true"
import script from "./UploadDetailsDrawer.vue?vue&type=script&lang=js"
export * from "./UploadDetailsDrawer.vue?vue&type=script&lang=js"
import style0 from "./UploadDetailsDrawer.vue?vue&type=style&index=0&id=cb02a4f2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb02a4f2",
  null
  
)

export default component.exports